import React from "react";
import LoginForm from "../LoginForm/LoginForm";
import "./Background.scss";

const Background = () => {
  return (
    <>
    <div className="background">
      <LoginForm />
    </div>

    </>
  );
};

export default Background;

